module.exports = __webpack_public_path__ + "media/AG-Production.b15766da.mp4";